import xw from 'xwind';

import getUrlToS3 from '@/utils/get-url-to-s3';
import {
  ImageWrapper,
  ImageContainer,
  Image,
  ContentCotainerWrapper,
  ContentCotainer,
  Title,
  Line,
  Text,
} from './Header.styles';

const Header = (): JSX.Element => {
  const imageUrl = getUrlToS3('/medical-review-board/hero.png');

  return (
    <div css={xw`flex justify-center items-center mb-10 md:mb-20`}>
      <ContentCotainerWrapper>
        <ContentCotainer css={xw`max-w-140`}>
          <Title>Medical Review Board</Title>
          <Line />
          <Text>
            Trust and accuracy are important, especially during times of
            uncertainty. That’s why our content is reviewed by at least one of
            our Medical Review Board members, a highly qualified team of
            well-recognized doctors in various disciplines in and around
            oncology.
          </Text>
          <Text>
            We have composed this board to ensure the safety and confidence of
            our community, alleviating concerns of validity and accuracy. Our
            board verifies that articles containing medical information reflect
            the latest in evidence-based research and health information.
          </Text>
          <Text>
            In addition to ensuring content quality, the Medical Review Board
            members will also participate with our Community through various
            forums, including seminars, panel discussions, and designated Office
            Hours.
          </Text>
        </ContentCotainer>
      </ContentCotainerWrapper>
      <ImageWrapper>
        <ImageContainer>
          {imageUrl && <Image src={imageUrl} alt="Medical Review Board" />}
        </ImageContainer>
      </ImageWrapper>
    </div>
  );
};

export default Header;
